import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderLoyaltyService } from 'src/app/_services/order-loyalty.service';
import { OrderItemsUtilsService } from '../../../order-items/order-items-util.service';
import { OfferComponent } from '../../../order-items/offer/offer.component';


import * as _ from 'lodash';
import {OrderItemsDialogsService} from "../../../order-items/order-items-dialogs.service";
declare const $: any;

@Component({
    selector: 'app-loyalty-benefit-offers-dialog',
    templateUrl: './loyalty-benefit-offers-dialog.component.html',
    styleUrls: ['./loyalty-benefit-offers-dialog.component.scss'],
    standalone: false
})
export class LoyaltyBenefitOffersDialogComponent implements OnInit {
	$storage;
	isMultiSelection;
	offerGroup;
	selecting: boolean;
	closing: boolean;
	deckClass = 'cols_3';
	benefitBasket: any;

	capOfOffersToSelect: string;

	constructor(
		public dialogRef: MatDialogRef<LoyaltyBenefitOffersDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public loyaltyService: OrderLoyaltyService,
		public orderDialogs: OrderItemsDialogsService,
	) {

		this.data.group.offers = this.data.group.offers.map(offer => {
			let basketQuantity = 0;
			this.data.orderBasket.forEach(o => {
				if (o.offer == offer.offer) {
					basketQuantity += (o.quantity || 1);
				}
			});
			return _.assignIn({}, offer, { _count: basketQuantity });
		});
		this.offerGroup = this.data.group;

		this.isMultiSelection = true;
		this.$storage = this.orderService.$storage;

		const numToSelect = this.data.numberOfOffersToSelect;
		this.capOfOffersToSelect = this.appService.translate(numToSelect == 1 ? '_LOYALTY.select_one_offers_for_benefit' : '_LOYALTY.select_count_offers_for_benefit', { val: numToSelect });
		this.benefitBasket = this.data.selectedOffers;
		this.fixOffersQuantity();

		// -------------------------------------------------------->

		let offersLength = this.offerGroup.offers.length;
		this.deckClass = `cols_${Math.min(offersLength, 3)}`;

		let gridSize = this.offerGroup.grid_size;
		if (gridSize) {
			let cols = gridSize.replace('cols_', '');
			if (isNaN(cols) || Number(cols) <= offersLength) this.deckClass = gridSize;
		}

	}

	ngOnInit(): void { }

	removeSelected(_offer, ev) {
		Promise.resolve().then(() => {
			let delOffer = this.benefitBasket.find(o => o.offer == _offer.offer);
			if (delOffer) return delOffer;
		}).then((delOffer) => {
			let index = this.benefitBasket.indexOf(delOffer);
			this.benefitBasket.splice(index, 1);
			this.fixOffersQuantity();
		});
	}

	async selectOffer(_offer, ev) {
		if (this.selecting) return;

		if (ev) ev.stopPropagation();
		if (_offer._disabled) {
			this.appService.alert({ content: this.appService.translate("ITEM_OUT_OF_STOCK_MESSAGE", { count: _offer.stock }) });
			return;
		}

		let newOrderOffer, availableOrderBasketOffer = this.data.orderBasket.find(orderBasketOffer => {
			if (orderBasketOffer.offer == _offer.offer) {
				let benefitBasketOffer = this.benefitBasket.find(o => o._bid == orderBasketOffer._bid);
				if (!benefitBasketOffer) {
					return true;
				}
			}
		});
		if (availableOrderBasketOffer) {
			if (availableOrderBasketOffer.quantity > 1) {
				newOrderOffer = this.splitOfferWithQuantity(availableOrderBasketOffer);
			} else {
				newOrderOffer = availableOrderBasketOffer;
			}
			await this.animateAddToBasket_alt(`#boffer_${_offer._id}`, this.appService.translate('TO.offer_added_to_benefit', { val: _offer.name }));
			if (newOrderOffer) this.addBenefitOffer(_offer, newOrderOffer);
		} else {
			let addedOrderOffer = await this.addSelectedOffer_to_order(_offer, ev);
			if (!_offer._count) _offer._count = 0;

			addedOrderOffer._bid = this.loyaltyService.getObjectId();
			if (!addedOrderOffer.quantity) addedOrderOffer.quantity = 1;
			_offer._count += addedOrderOffer.quantity;

			this.$storage.basket.push(addedOrderOffer);
			this.orderService.calculateBasketTotal();

			await this.animateAddToBasket_alt(`#boffer_${_offer._id}`, this.appService.translate('TO.offer_added_toast', { val: _offer.name }));

			this.data.orderBasket.push(addedOrderOffer);
			let remainingQuantity = this.data.numberOfOffersToSelect - this.benefitBasket.length;
			while (remainingQuantity > 0) {
				if (addedOrderOffer.quantity == 1) {
					this.addBenefitOffer(_offer, addedOrderOffer);
					break;
				}

				let splitOrder = this.splitOfferWithQuantity(addedOrderOffer);
				this.addBenefitOffer(_offer, splitOrder);
				--remainingQuantity;
			}
			this.orderService.calculateBasketTotal();
		}
	}

	async animateAddToBasket_alt(selector, message) {
		let that = this;
		return new Promise((resolve, reject) => {
			try {
				this.selecting = true;
				const container = document.querySelector(selector);
				container.classList.add('with-overlay');
				const htmlString = `<div class='menu-offer-overlay animated faster zoomIn'>${message}</div>`;
				container.insertAdjacentHTML("beforeend", htmlString);
				const overlayElement = container.lastElementChild;

				setTimeout(() => {
					overlayElement.classList.remove('animated', 'zoomIn');
					overlayElement.classList.add('animated', 'lightSpeedOutLeft', 'fastest');
					overlayElement.addEventListener('animationend', function () {
						that.selecting = false;
						resolve(null);
						overlayElement.remove();
						container.classList.remove('with-overlay');
					});
				}, 2000);
			} catch (e) {
				resolve(null);
			}
		});

	}

	addBenefitOffer(_offer, newOrderOffer) {
		this.benefitBasket.push({ _bid: newOrderOffer._bid, offer: newOrderOffer.offer });

		if (this.benefitBasket.length == this.data.numberOfOffersToSelect) {
			this.selecting = true;
			setTimeout(() => {
				this.apply();
			}, 500);
		} else if (this.benefitBasket.length > this.data.numberOfOffersToSelect) {
			let delOfferIndex = _.findIndex(this.benefitBasket, (o: any) => o.offer != _offer.offer);
			this.benefitBasket.splice(delOfferIndex, 1);
		}
		this.fixOffersQuantity();
	}

	splitOfferWithQuantity(_offer) {
		let newOffer = _.cloneDeep(_offer);
		newOffer.quantity = 1;
		newOffer._bid = this.orderUtils.getObjectId();
		_offer.quantity = _offer.quantity - 1;
		this.$storage.basket.push(newOffer);
		this.data.orderBasket.push(newOffer);
		return newOffer;
	}

	fixOffersQuantity() {
		this.offerGroup.offers.forEach(offer => {
			offer._selectedCount = this.benefitBasket.filter(o => o.offer == offer.offer).length;
		});
	}

	async addSelectedOffer_to_order(_offer, ev) {
		let viewItem = _.cloneDeep(_offer);
		this.orderUtils.prepareViewItem(this.$storage.catalog, viewItem);
		this.orderUtils.prepareSelectItem(this.$storage.catalog, viewItem);

		if (viewItem._enableEdit || !this.orderUtils.validateOffer(viewItem)) {
			return this.editOffer(_offer);
		}

		viewItem.total = viewItem.price;
		if (viewItem._item && viewItem._item._addPrice) {
			viewItem.total += viewItem._item._addPrice;
		}
		viewItem.quantity = 1;

		++_offer._count;
		++this.data.totalSelected;
		return viewItem;
	}

	editOffer(_offer: any) {
		return new Promise((resolve, reject) => {
			this.orderDialogs.openOfferDialog(_offer).then((result: any) => {
				if (result) {
					resolve(result.viewItem);
				}
			});
		});
	}

	apply() {
		if (this.benefitBasket.length < this.data.numberOfOffersToSelect) {
			this.appService.alert({
				html: [
					this.capOfOffersToSelect,
					this.appService.translate('_LOYALTY.benefit_offers_selected_count', { val: this.data.numberOfOffersToSelect})
				].join("<br/>")
			});
			return;
		}

		let orderOffers = [];
		this.benefitBasket.forEach(benefitOffer => {
			let basketOffer = this.$storage.basket.find(o => o._bid == benefitOffer._bid);
			if (basketOffer) orderOffers.push(basketOffer);
		});

		if (orderOffers.length != this.benefitBasket.length) {
			this.appService.alert({ content: "MESSAGES.LOAD_RESOURCE_ERROR" });
			return;
		}

		const benefitId = this.data.benefit.id;
		this.$storage.basket.forEach(basketOffer => {
			if (basketOffer._reserved?.benefitId == benefitId) delete basketOffer._reserved;
		});
		orderOffers.forEach(offer => {
			offer._reserved = { benefitId };
		});
		this.data.benefit.active = true;
		this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);

		this.closing = true;
		setTimeout(() => {
			this.dialogRef.close({ type: 'apply', benefit: this.data.benefit });
		}, 500);


	}
	clear() {
		const benefitId = this.data.benefit.id;
		this.$storage.basket.forEach(basketOffer => {
			if (basketOffer._reserved?.benefitId == benefitId) delete basketOffer._reserved;
		});
		this.data.benefit.active = false;
		this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);
		this.dialogRef.close({ type: 'clear', benefit: this.data.benefit });
	}
	close() {
		if (this.loyaltyService.loyaltyMember?.workFlow == 'CouponCode') {
			this.appService.confirm({
				content: this.appService.translate('_LOYALTY.coupon_required_prompt'),
				confirmText: this.appService.translate('_LOYALTY.continue_without_coupon'),
				cancelText: this.appService.translate('_LOYALTY.continue_without_cancel'),
			}).then(confirmed => {
				this.dialogRef.close({type: 'close', benefit: this.data.benefit});
			});
		} else {
			this.dialogRef.close({type: 'close', benefit: this.data.benefit});
		}
	}



}
